import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { openClose } from '@core/animations/animations';
import { Employee } from '@models/company';
import { Brokerage } from '@models/matter';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { BrokerSearchState } from '@state/algolia-search/broker-search';
import { BrokerSearchDispatch } from '@state/algolia-search/broker-search/broker-search.dispatch';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { ICON } from '@core/util/icon';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { TestHooks } from './broker-side-form.hooks';

@UntilDestroy()
@Component({
	selector: 'app-broker-side-form',
	templateUrl: './broker-side-form.component.html',
	animations: [openClose(300)],
	standalone: false,
})
export class BrokerSideFormComponent {
	testHooks = TestHooks;
	public _brokerName = '';
	public _focus = false;
	public ICON = ICON;
	public hoverShadow = true;
	public showCreateForm = false;

	@SelectSnapshot(SelectedMatter.id) saleId;

	@ViewSelectSnapshot(BrokerSearchState.getList) searchResult;

	@Input() brokerage: Brokerage;
	@Input() isClient;

	@Output() onSelectedBroker = new EventEmitter<Employee>();
	@Output() onRemoveBroker = new EventEmitter<string>();
	@Output() onCreateBroker = new EventEmitter<Employee>();
	@Output() onFocus = new EventEmitter();

	constructor(
		private navigationService: NavigationService,
		private route: ActivatedRoute,
		private brokerSearchDispatch: BrokerSearchDispatch,
	) {}

	_onFocus() {
		this.onFocus.emit();
		this._focus = true;
	}

	setBroker(ev: DropdownResult<Employee>) {
		if (ev.group === 1) {
			const { result } = ev;
			this.onSelectedBroker.emit(result);
		}
	}

	removeBroker(ev) {
		this.onRemoveBroker.emit(ev);
		this._brokerName = '';
	}

	createBroker() {
		this.showCreateForm = true;
	}

	_onCreateBroker(event: Employee) {
		this.showCreateForm = false;
		this.onCreateBroker.emit(event);
	}

	searchBrokers(value) {
		this.brokerSearchDispatch.Search(
			value,
			this.brokerage.id,
			this.brokerage.leap?.cardId,
		);
	}

	brokerDropdownOptionSelect(event: DropdownResult<{ name: string }>) {
		switch (event.result.name) {
			case 'Edit':
				this._brokerName = `${this.brokerage.broker.firstName} ${this.brokerage.broker.lastName}`;
				this.navigationService.goToUrl('edit-agent', null, {
					relativeTo: this.route,
					state: { brokerage: this.brokerage, isClient: this.isClient },
				});
				break;
			case 'Remove':
				this.removeBroker(this.brokerage.id);
				break;
		}
	}

	onCancel() {
		this.showCreateForm = false;
	}
}
